exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-group .honorific {\r\n    width: 150px;\r\n    float: left;\r\n}\r\n\r\n.field-group .contact-name {\r\n    float: left;\r\n    width: calc(100% - 295px);\r\n    margin-left: 10px;\r\n}\r\n\r\n.form-control.selectbox {\r\n    height: auto;\r\n    min-height: calc(2.25rem + 2px);\r\n    padding: 0.5rem 0.75rem;\r\n    line-height: 1.5;\r\n}\r\n\r\n.form-control:invalid {\r\n    box-shadow: 0 0 1.5px 1px red;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/common/Common.css
// module id = 368
// module chunks = 0